import {Component, OnInit} from '@angular/core';
import {UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {takeUntil} from 'rxjs/operators';
import {BaseFieldType} from 'compob2b-libs';

@Component({
  selector: 'app-link-property',
  templateUrl: './link-property.component.html',
})
export class LinkPropertyComponent extends BaseFieldType implements OnInit {
  header = '';
  url = '';
  formLink = new UntypedFormGroup({
    header: new UntypedFormControl(null),
    url: new UntypedFormControl(null),
  });

  ngOnInit(): void {
    if (this.field.defaultValue !== null && this.field.defaultValue !== undefined) {
      const link = JSON.parse(this.field.defaultValue);
      if (link) {
        this.formLink.patchValue(link);
      }
    }

    this.formLink.valueChanges
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(data => {
        this.formControl.setValue(JSON.stringify(data));
        this.formControl.markAsTouched();
      });
  }

}
